import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, FormattedMessage} from 'react-intl';
import Relay from 'react-relay';
import ScenarioBox from './ScenarioBox.react';
import NoScenariosMail from '../web/noScenariosMail.react';
import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';
import {getSelected, getSelectedFragnents, SCENARIOS_GEERAL_LIMIT, ApplicationObserver, MAX_APPLICATION_SELECTED} from '../web/SelectWidget.react';
import {LoadingLine} from '../loadingLine/renderLoadingPanel.react';
import diff from 'deep-diff';
import LoadingButtonNew from '../fw/LoadingButtonNew.react';

import '../layout.scss';
import './Scenario.scss';

const SCENARIOS_APP_QUERY_LIMIT = 1000;

class ScenarioListPure extends React.Component {
	static propTypes = {
		getScenarioClass: PropTypes.func,
		intl: PropTypes.object.isRequired,
		onClick: PropTypes.func,
		relay: PropTypes.object,
		user: PropTypes.object
	}

	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			loadingMore: false
		};

		// hack for server side rendering
		setTimeout(() => {
			try {
				this.setState({
					loading: true
				});
			} catch (e) {}
		}, 0);
	}

	componentDidMount() {
		let loadingEl = document.querySelector('#relayLoading');

		if (loadingEl) {
			loadingEl.remove();
		}

		this.loadingStop();

		this.applicationObserver = (applications) => {
			this.onApplicationChange(applications);
		};

		ApplicationObserver.subscribe(this.applicationObserver);
	}

	componentWillUnmount() {
		ApplicationObserver.unsubscribe(this.applicationObserver);
	}

	componentDidUpdate(prevProps) {
		if (diff(prevProps.user, this.props.user)) {
			this.loadingStop();
		}
	}

	loadingStop() {
		setTimeout(() => {
			LoadingLine.stop();
			this.setState({
				loading: false,
				loadingMore: false
			});
		}, 1);
	}

	onApplicationChange(applications) {
		LoadingLine.start();
		this.setState({
			loading: true
		});

		this.props.relay.setVariables({
			relevantScenariosCnt: applications.length > 0 ? SCENARIOS_APP_QUERY_LIMIT : SCENARIOS_GEERAL_LIMIT,
			channelDefUrlFragments: applications.map(app => app.urlFragment)
		});
	}

	loadMore() {
		LoadingLine.start();
		this.setState({
			loadingMore: true
		});

		let cnt = (Math.floor(this.props.relay.variables.relevantScenariosCnt / 9) + 1) * SCENARIOS_GEERAL_LIMIT + 1; //select one more for next page info

		this.props.relay.setVariables({
			relevantScenariosCnt: cnt
		});
	}

	render() {
		let selected = getSelected();
		let applicationsSelected = selected ? selected.length : 0;

		let topHeaderText = null;
		let scenariosCnt = this.props.user.exactMatches && this.props.user.exactMatches.edges ? this.props.user.exactMatches.edges.length : 0;
		switch (applicationsSelected) {
			case 0:
				topHeaderText = (<FormattedMessage defaultMessage="All scenarios" id="scenarioFinder.allScenarios" />);
				break;
			case 1:
				let applicationName = selected[0].name;
				if (scenariosCnt > 0) {
					topHeaderText = (<FormattedMessage defaultMessage="{cnt, plural, one {Scenario} other {All scenarios}} for {applicationName}" id="scenarioFinder.allScenariosForApplication" values={{applicationName: applicationName, cnt: scenariosCnt}} />);
				}
				else {
					topHeaderText = (<FormattedMessage defaultMessage="No scenarios for {applicationName}" id="scenarioFinder.noScenarios" values={{applicationName: applicationName}} />);
				}
				break;
			default:
				topHeaderText = (<FormattedMessage defaultMessage="Matched {cnt, plural, one {scenario} other {scenarios}}" id="scenarioFinder.exactMatchesNew" values={{cnt: scenariosCnt}} />);
				break;
		}

		return (
			<div className="scenarioList">
				<LoadingLine />
				<div className={'loadingOverflow' + (this.state.loading ? ' active' : '')}>
					<h3><span className="fa fa-spin fa-spinner"/><FormattedMessage defaultMessage="Loading integration scenarios" id="scenarioFinder.loadingScenarios" /></h3>
				</div>
				<div className="scenarioListHeader layout-row">
					<h4 className="flex-none">{topHeaderText}</h4>
					<span className="flex" />
					<div className={"resultsCount flex-none" + (applicationsSelected !== 0 ? '' : ' hidden')} >
						<FormattedMessage defaultMessage="{cnt, number} {cnt, plural, one {scenario} other {scenarios}} found" id="scenarioFinder.scenariosCount" values={{cnt: scenariosCnt}} />
					</div>
				</div>
				{scenariosCnt > 0 ? this.props.user.exactMatches.edges.map(({node}, idx) => {
					return (<ScenarioBox className={this.props.getScenarioClass ? this.props.getScenarioClass(node) : null} key={node.realId} metadata={types['scenarios']} onClick={this.props.onClick} scenario={node} urlMapping={urlMapping} />);
				}) :  (<NoScenariosMail selectedApplications={getSelected()} />)}

				{this.props.user.exactMatches && this.props.user.exactMatches.pageInfo.hasNextPage ? <div className="loadMore" id="loadMoreButtonWrapper">
					<LoadingButtonNew
						className="btn btn-primary"
						icon="fa-chevron-circle-down"
						isLoading={this.state.loadingMore}
						onClick={() => this.loadMore()}
						progressText={<FormattedMessage defaultMessage="Loading" id="scenarioFinder.loadingProgress"/>}
						text={<FormattedMessage defaultMessage="Load more…" id="scenarioFinder.loadingMore"/>}
						type="button"
						withoutDone
					/>
				</div> : null}

				{this.props.user.partialMatches && this.props.user.partialMatches.edges && this.props.user.partialMatches.edges.length ? (<div>
					<div className="scenarioListHeader layout-row">
						<h4 className="flex-none">
							{ applicationsSelected === 2
								? (<FormattedMessage defaultMessage="Additional {cnt, plural, one {match} other {matches}} with {app1} and {app2}" id="scenarioFinder.matchesWithApp1and2" values={{cnt: this.props.user.partialMatches.edges.length, app1: selected[0].name, app2: selected[1].name}} />)
								: (<FormattedMessage defaultMessage="Partial {cnt, plural, one {match} other {matches}}" id="scenarioFinder.partialMatches" values={{cnt: this.props.user.partialMatches.edges.length}} />)
							}
						</h4>
						<span className="flex" />
						<div className={"resultsCount flex-none" + (applicationsSelected !== null ? '' : ' hidden')} >
							<FormattedMessage defaultMessage="{cnt, number} {cnt, plural, one {scenario} other {scenarios}} found" id="scenarioFinder.scenariosCount" values={{cnt: this.props.user.partialMatches.edges.length}} />
						</div>
					</div>

					{this.props.user.partialMatches.edges.map(({node}, idx) => {
						return (<ScenarioBox className={this.props.getScenarioClass ? this.props.getScenarioClass(node) : null} key={node.realId} metadata={types['scenarios']} onClick={this.props.onClick} scenario={node} urlMapping={urlMapping} />);
					})
				}</div>) : null}

				{applicationsSelected > MAX_APPLICATION_SELECTED ? (<div>
					<div className="scenarioListHeader layout-row">
						<h4 className="flex-none"><FormattedMessage defaultMessage="Partial {cnt, plural, one {match} other {matches}}" id="scenarioFinder.partialMatches" values={{cnt: 10}} /></h4>
						<span className="flex" />
					</div>
					<div className="dativeryPlatformBox">
						<div className="dativeryPlatformContent dativeryPlatformContentError text-danger">
							<small><strong><i aria-hidden="true" className="fa fa-lg fa-exclamation-triangle"></i> <FormattedMessage defaultMessage="Too many selected applications for generating partial matches." id="scenarioFinder.limit" /></strong></small>
						</div>
					</div>
				</div>) : null }
			</div>
		);
	}
}

export default Relay.createContainer(injectIntl(ScenarioListPure), {
	initialVariables: {
		relevantScenariosCnt: 0,
		channelDefUrlFragments: null,
		partialMatches: false,
	},
	prepareVariables (variables) {
		variables.channelDefUrlFragments = getSelectedFragnents();

		if (variables.channelDefUrlFragments && variables.channelDefUrlFragments.length) {
			variables.relevantScenariosCnt = SCENARIOS_APP_QUERY_LIMIT;
		}
		else if (variables.relevantScenariosCnt === 0) {
			variables.relevantScenariosCnt = SCENARIOS_GEERAL_LIMIT;
		}

		if (variables.channelDefUrlFragments && variables.channelDefUrlFragments.length && variables.channelDefUrlFragments.length >= 2 && variables.channelDefUrlFragments.length <= MAX_APPLICATION_SELECTED) {
			variables.partialMatches = true;
		}
		else {
			variables.partialMatches = false;
		}

		return variables;
	},
    fragments: {
        user: () => Relay.QL`
            fragment on User {
				exactMatches : relevantScenarios(first: $relevantScenariosCnt, channelDefUrlFragments: $channelDefUrlFragments, channelDefUrlFragmentsJoinType: "and") {
                    edges {
                        node {
                            id,
							realId,
                            ${ScenarioBox.getFragment('scenario')}
                        }
                    },
                    pageInfo {
                        hasNextPage,
                        hasPreviousPage,
                        startCursor,
                        endCursor
                    }
                },
				partialMatches : relevantScenarios(first: $relevantScenariosCnt, channelDefUrlFragments: $channelDefUrlFragments, channelDefUrlFragmentsJoinType: "or") @include(if: $partialMatches) {
                    edges {
                        node {
                            id,
							realId,
                            ${ScenarioBox.getFragment('scenario')}
                        }
                    },
                    pageInfo {
                        hasNextPage,
                        hasPreviousPage,
                        startCursor,
                        endCursor
                    }
                },
			},
        `,
    },
});
